




































































































































































import { getUserData } from "@/auth/getUserData";
import VariablePicker from "@/components/variablePicker.vue";
// @ts-ignore
import Ability from "@/libs/acl/ability";
import axios from "@/libs/axios";
// @ts-ignore
import i18n from "@/libs/i18n";
import { useToast } from "vue-toastification/composition";
import useAssets from "@/composables/useAssets";
import useFileUploads from "@/composables/useFileUploads";
import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import { AssetInterface } from "@/interfaces/asset.interface";
import { useChannelsStore } from "@/store/useChannelsStore";

import { resolvePlatformIcon } from "@/utils/channels";
// @ts-ignore
import { addDataToInput } from "@/utils/input";
// @ts-ignore
import { required } from "@validations";
import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import {
    BButton,
    BCol,
    BForm,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormTextarea,
    BListGroup,
    BListGroupItem,
    BPopover,
    BRow,
    BFormFile,
    BSpinner,
    VBTooltip,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import emojiPicker from "./emojiPicker.vue";

export default defineComponent({
    components: {
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BButton,
        BFormCheckbox,
        BFormCheckboxGroup,
        BFormRadioGroup,
        BFormInput,
        BFormTextarea,
        BPopover,
        BListGroup,
        BListGroupItem,
        ValidationProvider,
        ValidationObserver,
        VariablePicker,
        BFormFile,
        BSpinner,
        emojiPicker,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        quickReplyId: {
            type: Number,
            required: false,
        },
    },
    emits: ["close-manage-quick-reply-panel", "update-quick-reply", "create-quick-reply"],
    data() {
        return {
            required,
            privacyOptions: [
                {
                    text: i18n.t("entities.quick-replies.manage.everybody"),
                    value: 0,
                },
                {
                    text: i18n.t("entities.quick-replies.manage.only-me"),
                    value: 1,
                },
            ],
        };
    },
    methods: {
        saveQuickReply(quickReplyData) {
            if (quickReplyData.id) {
                this.$emit("update-quick-reply", quickReplyData);
            } else {
                this.$emit("create-quick-reply", quickReplyData);
            }
        },
        validationForm() {
            // @ts-ignore
            this.$refs.simpleRules.validate().then((success) => {
                if (success) {
                    this.saveQuickReply(this.quickReply);
                }
            });
        },
    },
    setup(props) {
        const toast = useToast();
        const { uploadFile, clearFiles, getAllowedFileTypes } = useFileUploads();
        const { retrieveAsset, getAsset, setAsset } = useAssets();
        const channelsStore = useChannelsStore();

        const quickReply = ref({
            title: "",
            channels: [],
            userId: getUserData().id,
            content: "",
            private: false,
            assetId: null,
        });

        if (typeof props.quickReplyId !== "undefined") {
            axios
                .get(`/quick-replies/${props.quickReplyId}`, {
                    params: {
                        fields: "id,title,content,private,assetId",
                        join: "channels||id",
                    },
                })
                .then((result) => (quickReply.value = result.data));
        }

        let cursorPosition = 0;

        const saveCursorPosition = (event) => {
            if (event) {
                cursorPosition = event.target.selectionStart;
            }
        };

        const selectEmoji = (emoji, inputFieldName) => {
            quickReply.value.content = addDataToInput(inputFieldName, quickReply.value.content || "", emoji.data);
        };

        const quickReplyTextArea = ref();

        const insertVariable = (variableString) => {
            quickReplyTextArea.value.$el.focus();

            quickReply.value.content =
                quickReply.value.content.substr(0, cursorPosition) +
                " " +
                variableString +
                quickReply.value.content.substr(cursorPosition, quickReply.value.content.length);
        };

        const asset = computed(() => getAsset(quickReply.value.assetId));

        watch(
            () => quickReply.value.assetId,
            () => {
                if (quickReply.value.assetId) {
                    retrieveAsset(quickReply.value.assetId);
                }
            },
            { immediate: true }
        );

        const allowedFileTypes = computed(() =>
            getAllowedFileTypes(null, {
                platform: channelsStore.activeChatChannel.platform.toLowerCase(),
                provider: channelsStore.activeChatChannel.provider.toLowerCase(),
            }).join(",")
        );

        const isUploadingAsset = ref(false);
        const uploadAsset = (event: unknown) => {
            isUploadingAsset.value = true;
            clearFiles();

            return uploadFile(event, 16, {
                platform: channelsStore.activeChatChannel.platform.toLowerCase(),
                provider: channelsStore.activeChatChannel.provider.toLowerCase(),
            })
                .then((uploadedAsset) => {
                    return axios.post<AssetInterface>(`assets`, uploadedAsset).then(({ data: newAsset }) => {
                        setAsset(newAsset.id, newAsset);
                        quickReply.value.assetId = newAsset.id;
                    });
                })
                .catch((error) => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("upload.failed"),
                            text: i18n.t(error.message ?? error),
                            icon: "times",
                            variant: "danger",
                        },
                    });
                })
                .finally(() => {
                    isUploadingAsset.value = false;
                });
        };

        const openFilePrompt = () => {
            document.getElementById("file")?.click();
        };

        const removeAsset = () => {
            quickReply.value.assetId = null;
        };

        const manageAnyQuickReply = Ability.rules
            .find((rule) => rule.subject === "quickReplies")
            .possession.includes("create:any");

        return {
            quickReply,
            quickReplyTextArea,
            resolvePlatformIcon,
            saveCursorPosition,
            insertVariable,
            selectEmoji,
            manageAnyQuickReply,
            channelsStore,
            i18n,
            isUploadingAsset,
            uploadAsset,
            allowedFileTypes,
            openFilePrompt,
            removeAsset,
            asset,
        };
    },
});
